import React from "react";
import NextImage from "../common/NextImage";

const RacecourseRow = ({ number, horse }) => {
  return (
    <div className="racecourse_row">
      <div className="rec_col form_num">
        <span className="num">{number}</span>
        <span className="form_num">{horse?.ffg}</span>
      </div>
      <div className="rec_col">
        <div className="hors_rce">
          <div className="img">
            <NextImage
              src={horse?.surl || `/assets/images/jack.png`}
              alt="horse"
              width={28}
              height={36}
              priority={false}
            />
          </div>
          <div className="hors_des">
            <span className="name">{horse?.nm} {horse?.dlst ? `(${horse?.dlst})` : null}</span>
            <span className="catagory_hors">{horse?.col}</span>
          </div>
        </div>
      </div>
      <div className="rec_col">{horse?.age}</div>
      <div className="rec_col">{horse?.wei}</div>
      <div className="rec_col">{horse?.or}</div>
      <div className="rec_col">
        <ul className="jocker_tran">
          <li><span>J:</span> {horse?.joc ? horse?.joc : "N/A"}</li>
          <li><span>T:</span> {horse?.tra}</li>
        </ul>
      </div>
    </div>
  );
};

export default RacecourseRow;
